import { Breadcrumbs } from '@showroomjs/ui';
import * as React from 'react';
import { CodeFrameContextProvider } from '../lib/code-frame-context';
import { useComponentMeta } from '../lib/component-props-context';
import { lazy } from '../lib/lazy';
import { useSize } from '../lib/use-size';
import { Div } from './base';
const StandaloneEditor = lazy(() => import('./standalone-editor-lazy'));
export const ComponentDocStandaloneEditor = (props) => {
    const componentMetadata = useComponentMeta();
    const breadcrumbRef = React.useRef(null);
    const breadcrumbSize = useSize(breadcrumbRef);
    const variables = breadcrumbSize
        ? {
            '--breadcrumb-height': `${breadcrumbSize.height}px`,
        }
        : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement(Breadcrumbs, { items: [
                {
                    label: componentMetadata ? componentMetadata.displayName : '??',
                    url: '../',
                },
                {
                    label: 'Example',
                },
            ], ref: breadcrumbRef }),
        React.createElement(Div, { css: { flex: 1 }, style: variables },
            React.createElement(CodeFrameContextProvider, { value: React.useMemo(() => ({
                    showDeviceFrame: props.showDeviceFrame,
                    frameDimensions: props.codeFrameDimensions,
                }), [props.showDeviceFrame, props.codeFrameDimensions]) },
                React.createElement(StandaloneEditor, null)))));
};
//# sourceMappingURL=component-doc-standalone-editor.js.map